module.exports = __webpack_public_path__ + "static/media/copy.c5274de6.svg";